import { customAlphabet } from 'nanoid'

const alphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

/*
This generates an 8 character length "unique" identifier
- How unique?
- According to https://zelark.github.io/nano-id-cc/ it would take 239 years
  of making one generation every hour to have 1% probability of having a collision.
  In our case, where the uuid's are organization name-spaced, this will be more than fine.
*/

export default function uuid() {
  return customAlphabet(alphabet, 8)()
}
